import React, { useEffect, useState } from "react";
import { Form, Row, Col, InputGroup, Button } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
    setActiveTab,
    setPaginationPageNumber,
    TriggerFilterButtonApi,
} from "../../../slices/common/reducer";
import { setQualificationFilterForm } from "../../../slices/qualification/qualificationsSlice";
import { QualificationFieldsJSON } from "./Json/QualificationFieldsJson";
import api from "../../../Utils/interface";

const QualificationFilter = () => {
    const dispatch = useDispatch();
    const filterForm = useSelector((state) => state.qualification.filter.form);

    const [agOptions, setAgOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);

    useEffect(() => {
        loadFilterOptions();
    }, []);

    const loadFilterOptions = async () => {
        try {
            // Load AG Options from all Affinity Groups (AGRP) using direct API call
            const response = await api.post(`/entity/getFilteredDataWithTabs/AGRP`, 
                {
                    enterpriseid: localStorage.getItem("enterpriseid")
                },
                {
                    params: {
                        page: 0,
                        size: -1,
                        listEntityType: "AGRP"
                    },
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );

            if (response?.data?.entity_list) {
                const uniqueAgs = [...new Set(response.data.entity_list.map(ag => ag.name).filter(Boolean))];
                setAgOptions(uniqueAgs.map(name => ({ value: name, label: name })));
            }

            // Load Category Options from JSON config
            const rawCategories = QualificationFieldsJSON["1001-customSelect"]?.["data-customvalue"];
            if (rawCategories) {
                const categories = rawCategories.split("#").map(cat => ({
                    value: cat,
                    label: cat.replace(/_/g, " ")
                }));
                setCategoryOptions(categories);
            }
        } catch (error) {
            console.log("Error loading filter options", error);
        }
    };

    const handleInputChange = (name, value) => {
        dispatch(setQualificationFilterForm({ name, value }));
        resetTabAndPageNumber();
        dispatch(TriggerFilterButtonApi());
    };

    const resetTabAndPageNumber = () => {
        dispatch(setPaginationPageNumber(0));
        dispatch(setActiveTab("ALL"));
    };

    const hasFilters = filterForm.qualification || filterForm.ag_name || filterForm.doctor_category;

    const handleClear = () => {
        dispatch(setQualificationFilterForm({ type: "reset" }));
        dispatch(TriggerFilterButtonApi());
        if (Object.keys(filterForm).length > 0) {
            resetTabAndPageNumber();
        }
    };

    return (
        <div className="filter-wrapper">
            <Form className="form-input">
                <Row className="align-items-center g-2">
                    <Form.Group as={Col}>
                        <InputGroup>
                            <InputGroup.Text id="basic-addon1">
                                <CiSearch />
                            </InputGroup.Text>
                            <Form.Control
                                type="text"
                                placeholder="Search for AG..."
                                name="qualification"
                                id="searchQuery"
                                className="org-searchbar"
                                value={filterForm.qualification || ""}
                                onChange={(e) =>
                                    handleInputChange(e.target.name, e.target.value)
                                }
                            />
                        </InputGroup>
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Select
                            isClearable
                            placeholder="Select AG"
                            name="ag_name"
                            options={agOptions}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            value={
                                agOptions.find(
                                    (itm) => itm.value === filterForm.ag_name
                                ) || null
                            }
                            onChange={(e) =>
                                handleInputChange("ag_name", e ? e.value : "")
                            }
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Select
                            isClearable
                            placeholder="Select Category"
                            name="doctor_category"
                            options={categoryOptions}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            value={
                                categoryOptions.find(
                                    (itm) => itm.value === filterForm.doctor_category
                                ) || null
                            }
                            onChange={(e) =>
                                handleInputChange("doctor_category", e ? e.value : "")
                            }
                        />
                    </Form.Group>
                    <Col xs="auto" className="ms-4">
                        <Button
                            variant="outline-secondary"
                            onClick={handleClear}
                            disabled={!hasFilters}
                            style={{
                                opacity: !hasFilters ? 0.4 : 1,
                            }}
                        >
                            Clear
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default QualificationFilter;